import { Text } from "@chakra-ui/react"
import React from "react"
import { Address } from "~/interfaces/entities/Address"
import AdressCountry from "./AddressCountry"
import { getAddressLines } from "./addressFormatter"

interface Props {
  address: Address
}

const AddressZA: React.FC<Props> = ({ address }) => {
  const addressLine = getAddressLines(address)
  const { name, city, state, postcode, country } = address

  return (
    <>
      {!!name && <Text>{name}</Text>}
      <Text>{addressLine}</Text>
      <Text>{city}</Text>
      <Text>{state}</Text>
      <Text>{postcode}</Text>
      <AdressCountry code={country} />
    </>
  )
}

export default AddressZA
